import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  loading: false,
  isLoggedIn: false,
  accessToken: null,
  user: {
    _id: null,
    firstName: null,
    lastName: null,
    email: null,
    lastLoggedIn: null,
    kycStatus: null,
    type: null,
    multiFactorAuth: false,
    roles: [],
    practice: [],
    permissions: [],
    location: null,
    createdAt: null,
    updatedAt: null,
  
  },
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      const { token, user } = action.payload || {};
      state.isLoggedIn = true;
      state.accessToken = token;
      state.user = user|| initialState;
    },
 
    kycVerification: (state, action) => {
      const { kycStatus } = action.payload;
      state.user.kycStatus = kycStatus;
    },

    logout: (state) => {
      state.email = '';
      state.password = '';
      state.isLoggedIn = false;
      state.accessToken = null;
    },
  },
});

export const { loginSuccess, logout, kycVerification } =
  authSlice.actions;

export default authSlice.reducer;
